module.exports = __webpack_public_path__ + "img/digital_marketing.e5bdfbe0.png";